import { render, staticRenderFns } from "./productManagement.vue?vue&type=template&id=ed946104&scoped=true&"
import script from "./productManagement.vue?vue&type=script&lang=js&"
export * from "./productManagement.vue?vue&type=script&lang=js&"
import style0 from "./productManagement.vue?vue&type=style&index=0&id=ed946104&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed946104",
  null
  
)

export default component.exports